module.exports = __webpack_public_path__ + "assets/blob-3.7f0f45cf.svg";